import {
  DashboardOutlined,
  TeamOutlined,
  UserOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import { Layout, Menu, Drawer } from "antd";
const { Sider } = Layout;

const CustomSidebarComponent = ({
  collapsed,
  setCollapsed,
  showDrawer,
  setShowDrawer,
  devSideBars
}) => {
  const navigate = useNavigate();


  function getItem(label, key, icon, children) {
    return {
      label,
      key,
      icon,
      children,
    };
  }


  const items = [
    getItem("Level Management", "/role/dashboard", <DashboardOutlined />, null),
    getItem("User Management", "/userList", <UserOutlined />, null),
    getItem("Role Management", "/roleList", <TeamOutlined />, null),
    getItem("Sync Management", "/syncList", <TeamOutlined />, null),
    getItem("Scheduler Management", "/schedulerManagement", <ClockCircleOutlined />, null),
    getItem("News Management", "/newsManagement", <ClockCircleOutlined />, null),
    getItem("Kill Switch", "/killSwitch", <TeamOutlined />, null),
    getItem("RHB DuitNow Management", "/rhbduitnow", <TeamOutlined />, null),
    getItem("Package Management", "/packageManagement", <TeamOutlined />, null),
  ];



  return (
    <Sider
      width="250"
      className="sidebar-sider"
      trigger={null}
      collapsible
      collapsed={collapsed}
    >
      <div className="sidebar-menu-logo" />
      <div className="d-flex flex-column justify-content-between">
        <div>
          {showDrawer ? (
            <Drawer
              headerStyle={{ height: "300px" }}
              placement="left"
              width="250"
              onClose={() => setShowDrawer(false)}
              open={showDrawer}
            >
              <Menu
                theme="light"
                mode="inline"
                items={items}
                onClick={(e) => {
                  setShowDrawer(false);
                  navigate(e.key);

                }}
              />
            </Drawer>
          ) : (
            <Menu
              // className="laundro-antd-menu"
              theme="light"
              mode="inline"
              items={items}
              onClick={(e) => {
                navigate(e.key);
              }}
            />
          )}
        </div>
      </div>
    </Sider>
  );
};

export default CustomSidebarComponent;
